// `svg` joint à une entrée de composant natif quand la page a chargé les dessins
// (bridge_icons.js, app Android seulement) : celui de son symbole `icon`, ou de
// l'ionicon `ion` quand la vue en veut un autre. L'action de réorganisation d'une
// liste a aussi son état actif : `activeIcon` / `activeIon` donnent `activeSvg`.
// Sans les dessins (iOS, web), l'entrée part telle quelle.
export function withIconSvg(item) {
  const icons = window.ListyBridgeIcons
  if (!icons) return item

  const svg = icons.svg(item.icon, item.ion)
  const activeSvg = icons.svg(item.activeIcon, item.activeIon)
  const children = item.children?.map(withIconSvg)
  return { ...item, ...(svg && { svg }), ...(activeSvg && { activeSvg }), ...(children && { children }) }
}
